// Polyfill for process (required by simple-peer for WebRTC)
import process from 'process/browser';
window.process = process;

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { installGlobalHttpInterceptor } from "./utils/httpInterceptor";
import { installBlankPageDiagnostics } from "./utils/blankPageDiagnostics";
import GlobalErrorBoundary from "./components/GlobalErrorBoundary";

// Install diagnostics & scoped HTTP interceptors for fetch and axios
installBlankPageDiagnostics();
installGlobalHttpInterceptor();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GlobalErrorBoundary>
      <App />
    </GlobalErrorBoundary>
  </React.StrictMode>,
);

// Register PWA service worker
serviceWorkerRegistration.register();
